import _get from 'lodash/get';


export const getExchangeRatesForEur = state => _get(state, 'init.exchangeRatesForEur.data');
export const getExchangeRatesForEurError = state => _get(state, 'init.exchangeRatesForEur.error');
